import type {ComboboxData} from '@mantine/core';
import {
  UserStatusEnum,
  CourseClassroomStateEnum,
  CourseAssignmentStateEnum,
  UserTypeEnum,
  TaskAssignmentStateEnum,
  TaskDefinitionStateEnum,
  ItemAssignmentStateEnum,
  FormStateEnum,
  RiskAssessmentCodeAreaEnum,
  SafetyEventStateEnum,
  ComplianceStandardTypeEnum,
  NotificationRuleTypeEnum,
  WorkflowStateEnum,
  JobHazardAnalysisStateEnum,
  ModuleEnum,
  InspectionStateEnum,
  DeficiencyStatusEnum,
} from 'src/api/ProactApiClient';
import {mapEnumToComboboxData} from 'src/utilities/enumUtils';

// Static combobox option sets for MantineReactTable column filters.

export const ActiveStateDataOptions = [
  {
    value: String(false),
    label: 'Inactive',
  },
  {
    value: String(true),
    label: 'Active',
  },
] as ComboboxData;

export const PublishedStateDataOptions = [
  {
    value: String(false),
    label: 'Draft',
  },
  {
    value: String(true),
    label: 'Published',
  },
] as ComboboxData;

export const YesNoStateDataOptions = [
  {
    value: String(false),
    label: 'No',
  },
  {
    value: String(true),
    label: 'Yes',
  },
] as ComboboxData;

export const VerifiedStateDataOptions = [
  {
    value: String(false),
    label: 'Unverified',
  },
  {
    value: String(true),
    label: 'Verified',
  },
] as ComboboxData;

export const UserStateDataOptions = mapEnumToComboboxData(UserStatusEnum);

export const CourseAssignmentEnrollmentDataOptions = [
  {
    value: String(false),
    label: 'Inactive Assignment',
  },
  {
    value: String(true),
    label: 'Active Assignment',
  },
] as ComboboxData;

export const CourseAssignmentTypeDataOptions = [
  {
    value: String(false),
    label: 'First-Time',
  },
  {
    value: String(true),
    label: 'Renewal',
  },
] as ComboboxData;

export const CourseClassroomStateDataOptions = mapEnumToComboboxData(
  CourseClassroomStateEnum
);

export const CourseAssignmentStateDataOptions = mapEnumToComboboxData(
  CourseAssignmentStateEnum
);

export const UserTypeDataOptions = mapEnumToComboboxData(UserTypeEnum);

export const TaskAssignmentStateDataOptions: ComboboxData = [
  {value: String(TaskAssignmentStateEnum.Viewed), label: 'Viewed'},
  {value: String(TaskAssignmentStateEnum.Assigned), label: 'Assigned'},
  {
    value: String(TaskAssignmentStateEnum.Submitted),
    label: 'Submitted for review',
  },
  {value: String(TaskAssignmentStateEnum.Completed), label: 'Completed'},
];

export const TaskDefinitionStateDataOptions = mapEnumToComboboxData(
  TaskDefinitionStateEnum
);

export const ItemAssignmentStateDataOptions: ComboboxData =
  mapEnumToComboboxData(ItemAssignmentStateEnum);

export const FormStateDataOptions = mapEnumToComboboxData(FormStateEnum);

export const AssetTypeDataOptions = [
  {
    value: String(false),
    label: 'Asset Group',
  },
  {
    value: String(true),
    label: 'Physical Asset',
  },
] as ComboboxData;
export const RiskAssessmentCodeAreaDataOptions = mapEnumToComboboxData(
  RiskAssessmentCodeAreaEnum
);

export const SafetyEventDataOptions =
  mapEnumToComboboxData(SafetyEventStateEnum);

export const InspectionStateDataOptions =
  mapEnumToComboboxData(InspectionStateEnum);

export const DeficiencyStatusDataOptions = mapEnumToComboboxData(
  DeficiencyStatusEnum
);

export const ComplianceStandardTypeDataOptions = [
  {
    value: String(ComplianceStandardTypeEnum.Custom),
    label: 'Custom',
  },
  {
    value: String(ComplianceStandardTypeEnum.EPA),
    label: 'EPA',
  },
  {
    value: String(ComplianceStandardTypeEnum.OSHA),
    label: 'OSHA',
  },
] as ComboboxData;

export const NotificationRuleTypeDataOptions: ComboboxData = [
  {
    value: String(NotificationRuleTypeEnum.Reminder),
    label: 'Reminder',
  },
  {
    value: String(NotificationRuleTypeEnum.ChangeEvent),
    label: 'Change Event',
  },
];

export const WorkflowStateDataOptions = mapEnumToComboboxData(WorkflowStateEnum);

export const JobHazardAnalysisStateDataOptions =
  mapEnumToComboboxData(JobHazardAnalysisStateEnum);

export const NotificationRuleModuleDataOptions: ComboboxData = [
  {value: String(ModuleEnum.Actions), label: 'Actions'},
  {value: String(ModuleEnum.Approvals), label: 'Approvals'},
  {value: String(ModuleEnum.AssignedForms), label: 'Assigned Forms'},
  {value: String(ModuleEnum.Attachments), label: 'Attachments'},
  {value: String(ModuleEnum.ToolboxTalks), label: 'Toolbox Talks'},
  {value: String(ModuleEnum.Forms), label: 'Forms'},
  {value: String(ModuleEnum.Personnel), label: 'Personnel'},
  {value: String(ModuleEnum.Training), label: 'Training'},
  {value: String(ModuleEnum.ItemTrackerAssignments), label: 'Item Tracker'},
  {value: String(ModuleEnum.SafetyEvent), label: 'Safety Event'},
];
